/** Open the Publish sheet (web): the dialog `PublishSheetHost` draws in the shell. */
import { showPublishSheet, type PublishSheetRequest } from './publish-sheet-store';

export function openPublishSheet(request: Omit<PublishSheetRequest, 'nonce'>) {
  showPublishSheet(request);
}
